import { combineReducers } from '@reduxjs/toolkit';
import projectsListReducer from './projectsListSlice';
import filtersReducer from './filters';
import exportReducer from './export/exportSlice';
import includeReducer from './include';

export default combineReducers({
  filters: filtersReducer,
  export: exportReducer,
  table: projectsListReducer,
  include: includeReducer,
});
